export default __webpack_public_path__ + "static/media/landscapetable.f143c9b8.webp";